/**
 * Hands the cart UI over to the Rebuy Smart Cart.
 *
 * The <cart-drawer> element is deliberately left in the DOM: product-form.js
 * sends the shopper to the cart page when it cannot find one, so removing it
 * would turn every add to cart into a full page load. The drawer is only kept
 * from opening, and when the Smart Cart is switched off in Rebuy the theme
 * drawer behaves exactly as it did before.
 */
(function () {
  if (window.__rebuyThemeCartDisabled) return;
  window.__rebuyThemeCartDisabled = true;

  // Rebuy adds this class and renders #rebuy-cart only when its Smart Cart is
  // actually going to take over the cart, so this is read at call time rather
  // than cached.
  function smartCartActive() {
    return document.body.classList.contains('smart-cart--enabled') && !!document.getElementById('rebuy-cart');
  }

  window.rebuySmartCartActive = smartCartActive;

  // Rebuy keeps its own scroll lock on body.rebuy-cart-visible, so releasing
  // the theme's lock here does not unlock the page behind the Rebuy cart.
  function forceClose(drawer) {
    drawer.classList.remove('animate', 'active');
    document.body.classList.remove('overflow-hidden');
  }

  if (!window.customElements || !customElements.whenDefined) return;

  customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawerElement = customElements.get('cart-drawer');
    if (!CartDrawerElement || typeof CartDrawerElement.prototype.open !== 'function') return;

    var open = CartDrawerElement.prototype.open;

    CartDrawerElement.prototype.open = function (triggeredBy) {
      if (!smartCartActive()) return open.call(this, triggeredBy);
      forceClose(this);
    };

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;

    // Anything that opens the drawer by setting classes directly (rather than
    // calling open()) would otherwise leave an invisible drawer holding focus.
    new MutationObserver(function () {
      if (smartCartActive() && drawer.classList.contains('active')) forceClose(drawer);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  });
})();
